// When used on multiple places, consider moving to a shared file and base the types of the schema
import { z } from "zod";
import { ZBoundingBox, ZCoordinate, ZDeviceCategoryEnum, ZDirection, ZDIsciplineEnum } from "./foundationSchema";
// When used on multiple places, consider moving to a shared file and base the types of the schema
export const ZTileSize = z.array(z.number()).min(2).max(2);
export const ZDevice = z.object({
    _id: z.any().optional(),
    boundingBox: ZBoundingBox.optional(), // Attched on frontend
    compCode: z.string(),
    coordinate: ZCoordinate,
    createdAt: z.string().datetime().optional(),
    description: z.string(),
    deviceCategory: ZDeviceCategoryEnum,
    direction: ZDirection,
    discipline: ZDIsciplineEnum,
    floor: z.string(),
    grid: z.any().optional(), // ZGrid.optional(),
    pns: z.string().optional(),
    productName: z.string().optional(),
    projectNo: z.string(),
    returnAirFlow: z.number().optional(),
    roomName: z.string().optional(),
    roomNumber: z.string(),
    supplyAirFlow: z.number().optional(),
    // Schematic ceiling footprint in tile units, e.g. [1, 3] or [2, 2].
    tileSize: ZTileSize.optional(),
    updatedAt: z.string().datetime().optional(),
    bottomEdgeHeightAboveFloorMm: z.number(),
    bottomEdgeHeightAboveFloorM: z.number().optional()
});
